// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"62fb721c","583":"24b3a4a0","610":"b799aaf6","728":"79129e5d"}[chunkId] + ".css";
};